import { nowadaysApiUrl } from "@/utils/url-utils";
import { SendResult } from "./types";

interface SendMessageArgs {
  text: string;
  accessToken: string;
  /** Event id when the user is on an event-specific page; omitted otherwise. */
  eventId?: number;
}

/**
 * POSTs a user message to the live-chat backend.
 *
 * @param args - Message text, current Supabase access token, and optionally
 *   the event id for context-aware routing.
 * @returns Discriminated union: `{ ok: true }` on 200, otherwise `{ ok: false, kind }`.
 *   `kind` maps HTTP status codes: 400→validation, 401→auth, 429→rateLimit, 5xx→server,
 *   fetch throw→network.
 */
export const sendSupportChatMessage = async ({ text, accessToken, eventId }: SendMessageArgs): Promise<SendResult> => {
  try {
    const body: { text: string; eventId?: number } = { text };
    if (eventId !== undefined) body.eventId = eventId;

    const response = await fetch(nowadaysApiUrl("/support-chat/messages"), {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (response.ok) return { ok: true };

    if (response.status === 400) return { ok: false, kind: "validation" };
    if (response.status === 401) return { ok: false, kind: "auth" };
    if (response.status === 429) return { ok: false, kind: "rateLimit" };
    return { ok: false, kind: "server" };
  } catch {
    return { ok: false, kind: "network" };
  }
};
